import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { toDoList } from '@/api/dashboard/waitdoApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '标题',
      dataIndex: 'formName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 30
    }, {
      title: '类型',
      dataIndex: 'category',
      ellipsis: true,
      align: 'center',
      width: 15
    }, {
      title: '申请人',
      dataIndex: 'startUserName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 30
    }, {
      title: '申请时间',
      dataIndex: 'startTime',
      ellipsis: true,
      align: 'center',
      width: 30
    }, {
      title: '当前审批节点',
      dataIndex: 'taskName',
      ellipsis: true,
      align: 'center',
      width: 20
    }, {
      title: '接收时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 30
    }, {
      title: '办理状态',
      dataIndex: 'status',
      align: 'center',
      width: 15,
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 15,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      pagination: this.$hdk.page(),
      expand: false,
      formState: {
        title: '',
        serialNumber: '',
        type: undefined,
        node: '',
        status: undefined,
        time: [],
        startTime: '',
        endTime: '',
        category: undefined
      },
      text: '',
      columns: columns,
      list: []
    };
  },
  created: function created() {
    this.fetch();
  },
  methods: {
    view: function view(row) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: row.procInsId
        }
      });
    },
    applyAudit: function applyAudit(record) {
      this.$router.push({
        path: '/formReview/reviewCenter/auditProcess',
        query: {
          procInsId: record.procInsId,
          taskId: record.taskId,
          path: 'waitdo'
        }
      });
    },
    search: function search() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.fetch();
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    change: function change(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
    },
    handleChange: function handleChange() {},
    fetch: function fetch(options) {
      var _this = this;
      var pagination = this.pagination,
        formState = this.formState,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.formState.time.length > 0) {
        this.formState.startTime = this.formState.time[0];
        this.formState.endTime = this.formState.time[1];
      } else {
        this.formState.startTime = null;
        this.formState.endTime = null;
      }
      if (!pager.formState) {
        pager.formState = formState;
      }
      toDoList(pager.current, pager.pageSize, pager.formState).then(function (res) {
        _this.list = res.data.data.rows;
        _.assign(pagination, {
          total: res.data.data.total,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(formState, pager.formState);
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {}
};